import React, { ReactNode } from "react";
import classnames from "classnames";

import { Icon } from "@sportal/cdk";

import "./SortButton.scss";

interface SortButtonProps {
  isSorted: boolean;
  isSortedDesc: boolean;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}

export const SortButton = ({
  isSorted,
  isSortedDesc,
  children,
  onClick,
  disabled,
  ...attrs
}: SortButtonProps) => {
  return (
    <button
      {...attrs}
      onClick={onClick}
      type="button"
      className="sort-button"
      disabled={disabled}
    >
      <span className="sort-button__content">{children}</span>

      <Icon
        aria-hidden={true}
        icon={classnames("sort-button__icon", {
          "fa-regular fa-sort-alt sort-button__icon--unsorted": !isSorted,
          "fa-regular fa-arrow-down-long": isSorted && isSortedDesc,
          "fa-regular fa-arrow-up-long": isSorted && !isSortedDesc,
        })}
      />
    </button>
  );
};
